<template>
  <div class="container">
    <p>技术领域分析分为检索分析与学科资讯，点击可跳转详情页。</p>
    <img src="../../assets/images/help/img21.png" alt="" />
    <p>在检索分析中，输入您的研究方向，系统自动进行分析查找，从论文数量、作者数量、机构数量、期刊数量四个维度分析发展历程，生成折线图供您参考，同时您可以点击查看每一项的具体名录，帮助您寻找更多资源与合作机会。</p>
    <img src="../../assets/images/help/img22.png" alt="" />
    <p>在学科资讯界面，您可以查看最前沿的通知、学术资讯、研究进展、获奖情况、学术论文等内容，同时系统对内容进行处理优化，捕捉最关键信息，帮助您快速获取最新学术动向，还可以按照学科分类查看或输入咨询关键词搜索。</p>
    <img src="../../assets/images/help/img23.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
